import React from 'react';
import './HeroSection.css';

function HeroSection({ searchQuery, onSearchChange }) {
  const handleSearch = (e) => {
    onSearchChange(e.target.value);
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h2 className="hero-title">आमची सांगली</h2>
          <p className="hero-subtitle">One Stop Solution For Your Business Search!!</p>
        </div>

        {/* Deity Image - Centered */}
        <div className="hero-image-container">
          <img 
            src="/hero-image.png" 
            alt="Sangli Temple Deity" 
            className="hero-image"
          />
        </div>

        <div className="search-container">
          <input
            type="text"
            placeholder="Search businesses or services..."
            value={searchQuery}
            onChange={handleSearch}
            className="search-input"
            aria-label="Search businesses"
          />
          <button className="search-button" aria-label="Search">
            🔍
          </button>
        </div>
      </div>

      <div className="hero-decoration"></div>
    </section>
  );
}

export default HeroSection;
